enum IssuerEInvoiceDocumentType {
  COLLECTION_NOTICE = 'COLLECTION_NOTICE',
  DUNNING = 'DUNNING',
  ENFORCEMENT_WARNING = 'ENFORCEMENT_WARNING',
  INVOICE = 'INVOICE',
  PAYMENT_REQUEST = 'PAYMENT_REQUEST',
  REMINDER = 'REMINDER',
  CREDIT_NOTE = 'CREDIT_NOTE',
  INVOICE_WITH_AVTALEGIRO = 'INVOICE_WITH_AVTALEGIRO',
}

export default IssuerEInvoiceDocumentType;
